import { useTranslation } from 'react-i18next';
import { FiArrowUp, FiArrowUpRight, FiMail } from 'react-icons/fi';

const footerLabels = {
  pt: {
    statement: 'AI, automação, software e marketing conectados ao crescimento do negócio.',
    solutions: 'Soluções',
    automation: 'Automação & AI',
    websites: 'Websites',
    apps: 'Apps personalizados',
    growth: 'Growth & Ads',
    company: 'MAIPRO',
    projects: 'Projetos',
    process: 'Como trabalhamos',
    product: 'Social Manager',
    contact: 'Falar sobre um projeto',
    legal: 'Legal',
    privacy: 'Privacidade',
    terms: 'Termos',
    data: 'Pedido de dados',
  },
  en: {
    statement: 'AI, automation, software and marketing connected to business growth.',
    solutions: 'Solutions',
    automation: 'Automation & AI',
    websites: 'Websites',
    apps: 'Custom apps',
    growth: 'Growth & Ads',
    company: 'MAIPRO',
    projects: 'Projects',
    process: 'How we work',
    product: 'Social Manager',
    contact: 'Discuss a project',
    legal: 'Legal',
    privacy: 'Privacy',
    terms: 'Terms',
    data: 'Data request',
  },
  fr: {
    statement: 'IA, automatisation, logiciel et marketing connectés à la croissance de l’entreprise.',
    solutions: 'Solutions',
    automation: 'Automatisation & IA',
    websites: 'Sites web',
    apps: 'Apps sur mesure',
    growth: 'Growth & Ads',
    company: 'MAIPRO',
    projects: 'Projets',
    process: 'Notre méthode',
    product: 'Social Manager',
    contact: 'Parler de votre projet',
    legal: 'Légal',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    data: 'Demande de données',
  },
};

const Footer = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language?.startsWith('en') ? 'en' : i18n.language?.startsWith('fr') ? 'fr' : 'pt';
  const copy = footerLabels[language];
  const currentYear = new Date().getFullYear();
  const email = t('contact.contactInfo.email.value');

  return (
    <footer className="maipro-footer">
      <div className="maipro-footer-inner">
        <div className="maipro-footer-lead">
          <a href="/" className="maipro-footer-wordmark"><span>MAIPRO</span><strong>Solutions</strong></a>
          <p>{copy.statement}</p>
          <a className="maipro-footer-mail" href={`mailto:${email}`}><FiMail /> {email}</a>
        </div>

        <div className="maipro-footer-column">
          <strong>{copy.solutions}</strong>
          <a href="/automacao-ai">{copy.automation}</a>
          <a href="/websites">{copy.websites}</a>
          <a href="/apps-sistemas">{copy.apps}</a>
          <a href="/growth-marketing">{copy.growth}</a>
        </div>

        <div className="maipro-footer-column">
          <strong>{copy.company}</strong>
          <a href="/projetos">{copy.projects}</a>
          <a href="/#process">{copy.process}</a>
          <a href="/social-manager">{copy.product}</a>
          <a href="/briefing">{copy.contact} <FiArrowUpRight /></a>
        </div>

        <div className="maipro-footer-column">
          <strong>{copy.legal}</strong>
          <a href="/privacy">{copy.privacy}</a>
          <a href="/terms">{copy.terms}</a>
          <a href="/data-request">{copy.data}</a>
        </div>
      </div>

      <div className="maipro-footer-bottom">
        <span>© {currentYear} MAIPROSolutions</span>
        <span>Web · Automation · Apps · Growth</span>
        <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Back to top">
          <FiArrowUp />
        </button>
      </div>
    </footer>
  );
};

export default Footer;
